import React, { useEffect, useState } from "react";
import { Form, Modal as RBModal } from "react-bootstrap";
import Button from "../Button";
import { FoodIDModalProps } from "./FoodIDModal.props";

const FoodIDModal = React.memo<FoodIDModalProps>(
    ({
        show,
        virtual = false,
        handleClose,
        handleConfirm,
        isBranch = false,
    }) => {
        const [id, setID] = useState<number>(0);
        const [isVirtual, setIsVirtual] = useState<boolean>(virtual);

        useEffect(() => {
            if (virtual && show) {
                setIsVirtual(true);
            }

            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [show]);

        const handleHide = () => {
            setID(0);
            setIsVirtual(false);
            handleClose();
        };

        const handleCheckChange = () => {
            setIsVirtual((prev) => !prev);
        };

        const handleSubmit = () => {
            handleConfirm(isVirtual, id);
            handleHide();
        };

        const checkIsDisabled = () => {
            let result = isVirtual
                ? false
                : id.toString() === "0" || id.toString().length === 1;

            return result;
        };

        return (
            <>
                <RBModal
                    show={show}
                    onHide={handleHide}
                    centered
                    dir="rtl"
                    className="rtl"
                    aria-labelledby="food-id__modal"
                >
                    <RBModal.Header closeButton>
                        <RBModal.Title id="food-id__modal">
                            <span>اضافه کردن آیدی جدید</span>
                        </RBModal.Title>
                    </RBModal.Header>

                    <RBModal.Body>
                        <div>
                            <Form.Group className="mb-3">
                                <Form.Label className="mb-3">
                                    آیا این آیدی به عنوان آیدی فعال در نظر گرفته
                                    شود؟
                                </Form.Label>
                                {!isBranch && (
                                    <Form.Check
                                        type="checkbox"
                                        className="d-flex align-items-center my-4"
                                    >
                                        <Form.Check.Input
                                            type="checkbox"
                                            className="mt-0"
                                            checked={isVirtual}
                                            onChange={handleCheckChange}
                                        />
                                        <Form.Check.Label
                                            style={{ marginRight: "32px" }}
                                        >
                                            آیدی مجازی
                                        </Form.Check.Label>
                                    </Form.Check>
                                )}
                                <Form.Control
                                    className="text-center w-75 mt-3 mr-0"
                                    type="number"
                                    min="0"
                                    onChange={(event) =>
                                        setID(Number(event.target.value))
                                    }
                                    defaultValue=""
                                    disabled={isVirtual}
                                />
                            </Form.Group>
                        </div>
                    </RBModal.Body>

                    <RBModal.Footer className="flex-nowrap justify-content-between">
                        <Button
                            className="is-green solid font-weight-normal big"
                            btnText="بله"
                            handleClick={handleSubmit}
                            disabled={checkIsDisabled()}
                        />
                        <Button
                            className="is-green bordered font-weight-normal big"
                            btnText="خیر"
                            handleClick={handleHide}
                        />
                    </RBModal.Footer>
                </RBModal>
            </>
        );
    }
);

export default FoodIDModal;
